import { useMutation } from 'react-query'

import { removeInspection } from 'services/inspections'

const useRemoveInspection = () => {
  return useMutation(removeInspection)
}

export default useRemoveInspection
